<template>
  <div v-if="recommend">
    <!-- <div v-if="currentTeacher" class="teacher-view">
      <div class="body">
        <img class="avatar" :src="currentTeacher.photo" />
        <div class="right">
          <div class="name-wrap">
            <span class="name">{{ currentTeacher.teacher_name }}</span>
            <span class="level" v-if="currentTeacher.level_name">
              {{ currentTeacher.level_name }}
            </span>
          </div>
          <div class="marketing_language">
            {{ currentTeacher.marketing_language }}
          </div>
          <div class="introduction">{{ currentTeacher.introduction }}</div>
        </div>
      </div>
      <div class="back"></div>
    </div> -->
    <div class="items clearfix">
      <div
        class="teacher-item"
        v-for="(item, index) in recommend.list"
        :key="index"
        :data="item"
        @mouseover.native="currentTeacherIndex = index"
      >
        <div class="wrap">
          <img class="avatar" :src="item.photo" />
          <div class="name">{{ item.teacher_name }}</div>
          <div class="line"></div>
          <div class="introduction">{{ item.marketing_language }}</div>
          <div
            class="tag"
            v-if="
              (item.level_name && $store.state.commonSetting.switch_oto_module == 1) ||
              item.is_invite_teacher == 1
            "
          >
            约课
          </div>
          <div class="arrow"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RecommendTeacher',
  props: {
    recommend: {
      type: Object,
    },
  },
  data() {
    return {
      currentTeacherIndex: 0,
    };
  },
};
</script>
<style lang="scss" scoped>
.items {
  width: 1200px;
  margin: 0 auto;
}
.teacher-item {
  &:nth-child(5n) {
    .wrap {
      margin-right: 0;
    }
  }
  &:hover {
    box-shadow: 0px 3px 15px 0px rgba(224, 224, 224, 1);
    .avatar {
      transform: scale(1.1);
    }
  }
}
.wrap {
  width: 220px;
  height: 348px;
  float: left;
  margin-right: 25px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    width: 100%;
    z-index: 99;
    height: 100%;
    background: url(~@/assets/images/common/Rectangle373@2x.png) no-repeat 100% 100%;
  }
}
.avatar {
  width: 100%;
  height: 100%;
  transform: scale(1);
  transition: 0.3s all;
  border: 1px solid #f0f0f0;
  display: block;
  margin: 0 auto 23px auto;
}
.name {
  position: absolute;
  width: 64px;
  height: 22px;
  bottom: 56px;
  font-size: 16px;
  font-weight: 500;
  color: white;
  z-index: 999;
  text-align: left;
  left: 50%;
  margin-left: -32px;
  line-height: 22px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
.line {
  position: absolute;
  bottom: 55px;
  left: 50%;
  margin-left: -32px;
  width: 64px;
  height: 5px;
  background: linear-gradient(90deg, #fee6b5, rgba(254, 230, 181, 0) 100%);
  border-radius: 4px;
  z-index: 999;
}
.introduction {
  position: absolute;
  margin-left: 12px;
  bottom: 20px;
  width: 195px;
  height: 22px;
  font-size: 13px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: white;
  z-index: 999;
  line-height: 22px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.tag {
  position: absolute;
  z-index: 999;
  width: 42px;
  height: 20px;
  background: $primary-color;
  font-size: 13px;
  color: white;
  line-height: 20px;
  box-sizing: border-box;
  text-align: center;
  border-radius: 5px 0px 8px 0px;
  top: 0;
  left: 0;
}
.arrow {
  width: 0;
  height: 0;
  border: 18px solid transparent;
  border-top-color: rgba($color: #f0f0f0, $alpha: 0.61);
  position: absolute;
  left: 50%;
  top: -32px;
  transform: translateX(-50%);
  display: none;
}
</style>
